import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { Module } from '../../models/global.types'

export interface ModuleState {
  firstActiveModule: string
  modules: Module[]
}

export const moduleInitialState: ModuleState = {
  firstActiveModule: '',
  modules: []
}

export const moduleSlice = createSlice({
  name: 'module',
  initialState: moduleInitialState,
  reducers: {
    setFirstActiveModule: (state, action: PayloadAction<string>) => {
      state.firstActiveModule = action.payload
    },
    setModules: (state, action: PayloadAction<Module[]>) => {
      state.modules = action.payload
    }
  }
})

export const {
  setFirstActiveModule,
  setModules
} = moduleSlice.actions

export default moduleSlice.reducer
